





































































































































































































































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import HydrationGuard from "@/mixins/HydrationGuard";
import RekamAsuhanHemodialisisSvc from "@/services/RekamAsuhanHemodialisis";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import AsesmenHemodialisisSection from "./AsesmenHemodialisisSection.vue";
import InstruksiMedikSection from "./InstruksiMedikSection.vue";
import MonitoringHemodialisisTable from "./MonitoringHemodialisisTable.vue";
import ObatCatatanMedisCard from "./ObatCatatanMedisCard.vue";
import PilihanChip from "./PilihanChip.vue";
import RiwayatPengisianHemodialisis from "./RiwayatPengisianHemodialisis.vue";
import { ATURAN, AturanIsian, maksKarakter } from "./aturanIsian";
import {
  AsesmenRah,
  AsuhanRahForm,
  InstruksiRah,
  InstruksiRahForm,
  KatalogRah,
  RekamAsuhanHemodialisis,
  RekamAsuhanHemodialisisUpdate,
  RiwayatRah
} from "@/types/rekam_asuhan_hemodialisis";

const FORM_CODE = "rekam_asuhan_hd";

const ANGKA_ASESMEN: Array<[keyof AsesmenRah, string]> = [
  ["nyeri", "skala"],
  ["fisik", "suhu"],
  ["fisik", "nadi_frek"],
  ["fisik", "respirasi_frek"],
  ["fisik", "bb_pre"],
  ["fisik", "bb_hd_lalu"],
  ["fisik", "bb_kering"],
  ["fisik", "bb_post"],
  ["gizi", "mis_skor"],
  ["gizi", "sga_skor"]
];

const ANGKA_INSTRUKSI: Array<keyof InstruksiRah> = [
  "durasi_jam",
  "qb",
  "qd",
  "uf_goal",
  "heparin_sirkulasi",
  "heparin_awal",
  "heparin_maintenance_dosis"
];

type PeranTtd = "perawat" | "dokter" | "dokter_catatan";

function salin<T>(v: T): T {
  return JSON.parse(JSON.stringify(v));
}

function rapikan<T>(v: T): T {
  if (typeof v === "string") {
    const s = v.trim();

    return ((s === "" ? null : s) as unknown) as T;
  }
  if (Array.isArray(v)) {
    return (v.map(it => rapikan(it)) as unknown) as T;
  }
  if (v && typeof v === "object") {
    const hasil: Record<string, unknown> = {};
    Object.keys(v as Record<string, unknown>).forEach(kunci => {
      hasil[kunci] = rapikan((v as Record<string, unknown>)[kunci]);
    });

    return (hasil as unknown) as T;
  }

  return v === undefined ? ((null as unknown) as T) : v;
}

function toNumberOrNull(v: unknown): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);

  return isNaN(n) ? null : n;
}

function asuhanDariDoc(doc: RekamAsuhanHemodialisis): AsuhanRahForm {
  return salin({
    waktu_hd: doc.waktu_hd,
    diagnosa_medis: doc.diagnosa_medis,
    no_mesin: doc.no_mesin,
    tipe_dialiser: doc.tipe_dialiser,
    alergi_obat: doc.alergi_obat,
    asuransi: doc.asuransi,
    asuransi_lain: doc.asuransi_lain,
    asesmen: doc.asesmen,
    penyulit: doc.penyulit,
    total_uf: doc.total_uf,
    akses_vaskuler_oleh_id: doc.akses_vaskuler_oleh_id,
    perawat_id: doc.perawat_id
  });
}

function ringkasan(doc: RekamAsuhanHemodialisis): RiwayatRah {
  return {
    id: doc.id,
    register_id: doc.register_id,
    waktu_hd: doc.waktu_hd,
    perawat_nama: doc.perawat_nama,
    perawat_signed_at: doc.perawat_signed_at,
    dokter_nama: doc.dokter_nama,
    dokter_signed_at: doc.dokter_signed_at,
    dokter_catatan_nama: doc.dokter_catatan_nama,
    dokter_catatan_signed_at: doc.dokter_catatan_signed_at
  };
}

function dokterLengkapPada(doc: RekamAsuhanHemodialisis | null): boolean {
  return !!doc?.dokter_signed_at && !!doc?.dokter_catatan_signed_at;
}

function instruksiDariDoc(doc: RekamAsuhanHemodialisis): InstruksiRahForm {
  const form: InstruksiRahForm = salin({
    instruksi: doc.instruksi,
    catatan_medis: doc.catatan_medis,
    dokter_id: doc.dokter_id,
    dokter_catatan_id: doc.dokter_catatan_id
  });
  if (!form.catatan_medis.length && !dokterLengkapPada(doc)) {
    form.catatan_medis.push({ obat: null, catatan: null });
  }

  return form;
}

function bersihkanAsuhan(form: AsuhanRahForm): AsuhanRahForm {
  const data = rapikan(form);
  ANGKA_ASESMEN.forEach(([bagian, kunci]) => {
    const isi = (data.asesmen[bagian] as unknown) as Record<string, unknown>;
    isi[kunci] = toNumberOrNull(isi[kunci]);
  });
  data.total_uf = toNumberOrNull(data.total_uf);
  if (data.asuransi !== "lainnya") data.asuransi_lain = null;

  return data;
}

function bersihkanInstruksi(form: InstruksiRahForm): InstruksiRahForm {
  const data = rapikan(form);
  ANGKA_INSTRUKSI.forEach(kunci => {
    ((data.instruksi as unknown) as Record<string, unknown>)[kunci] = toNumberOrNull(data.instruksi[kunci]);
  });
  data.catatan_medis = data.catatan_medis.filter(baris => baris.obat !== null || baris.catatan !== null);

  return data;
}

@Component({
  components: {
    AsesmenHemodialisisSection,
    CardModalTtd,
    InstruksiMedikSection,
    MonitoringHemodialisisTable,
    ObatCatatanMedisCard,
    PersonAutoComplete,
    PilihanChip,
    RiwayatPengisianHemodialisis,
    VCDateTimePicker
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class RekamAsuhanHemodialisisPage extends Mixins(HydrationGuard) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
  @Prop({ type: String, default: "ralan" }) readonly encounterType!: string;
  isReadOnly!: () => boolean;

  katalog: KatalogRah | null = null;
  daftar: RekamAsuhanHemodialisis[] = [];
  riwayat: RiwayatRah[] = [];
  doc: RekamAsuhanHemodialisis | null = null;
  asuhan: AsuhanRahForm | null = null;
  instruksiForm: InstruksiRahForm | null = null;

  loading = false;
  creating = false;
  saving = false;
  printingId: number | null = null;
  pesanValidasi = "";
  ATURAN = ATURAN;
  maksKarakter = maksKarakter;
  deleting = false;
  signing: PeranTtd | null = null;
  peranTtd: PeranTtd | null = null;
  modalTtd = false;
  requestSeq = 0;

  get urutanDoc(): number {
    const doc = this.doc;

    return doc ? this.daftar.length - this.daftar.findIndex(it => it.id === doc.id) : 0;
  }

  get adaPerubahan(): boolean {
    return (!this.asuhanLockReason && this.asuhanDirty) || (!this.instruksiLockReason && this.instruksiDirty);
  }

  aturanAsuhan(fn: AturanIsian): AturanIsian[] {
    return this.canEditAsuhan ? [fn] : [];
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get isRanap(): boolean {
    return this.encounterType === "ranap";
  }

  get userId(): number | null {
    return userModule.user?.id ?? null;
  }

  get canFill(): boolean {
    return userModule.canAccessForm(FORM_CODE, "create");
  }

  get perawatSigned(): boolean {
    return !!this.doc?.perawat_signed_at;
  }

  get dokterSigned(): boolean {
    return !!this.doc?.dokter_signed_at;
  }

  get dokterCatatanSigned(): boolean {
    return !!this.doc?.dokter_catatan_signed_at;
  }

  get dokterLengkap(): boolean {
    return dokterLengkapPada(this.doc);
  }

  get keteranganKunciDokter(): string {
    if (this.dokterSigned) {
      return "TTD Dokter 1 sudah ada. Instruksi medik serta obat & catatan medis terkunci setelah TTD Dokter 2.";
    }
    if (this.dokterCatatanSigned) {
      return "TTD Dokter 2 sudah ada. Instruksi medik serta obat & catatan medis terkunci setelah TTD Dokter 1.";
    }

    return "Instruksi medik serta obat & catatan medis terkunci setelah TTD Dokter 1 dan TTD Dokter 2 ada.";
  }

  get bisaHapus(): boolean {
    const doc = this.doc;

    return !!doc && !this.readOnly && doc.creator_user_id !== null && doc.creator_user_id === this.userId;
  }

  get aksesReason(): string {
    if (this.readOnly) return "Formulir terkunci: rekam medis kunjungan ini sudah terkunci.";
    if (!this.canFill) return "Akun/unit login Anda tidak termasuk dokter/perawat unit Hemodialisa, ICU, ICCU, atau HCU.";

    return "";
  }

  get asuhanLockReason(): string {
    if (this.perawatSigned) return "Asuhan sudah ditandatangani perawat dan terkunci.";

    return this.aksesReason;
  }

  get instruksiLockReason(): string {
    if (this.dokterLengkap) return "Instruksi medik serta obat & catatan medis sudah ditandatangani dokter dan terkunci.";

    return this.aksesReason;
  }

  get canEditAsuhan(): boolean {
    return !this.asuhanLockReason && !this.busy;
  }

  get canEditInstruksi(): boolean {
    return !this.instruksiLockReason && !this.busy;
  }

  get canPilihDokter(): boolean {
    return this.canEditInstruksi && !this.dokterSigned;
  }

  get canPilihDokterCatatan(): boolean {
    return this.canEditInstruksi && !this.dokterCatatanSigned;
  }

  get createBlockReason(): string {
    if (this.readOnly) return "Tidak dapat membuat formulir: rekam medis kunjungan ini sudah terkunci.";
    if (!this.canFill) return "Akun/unit login Anda tidak termasuk dokter/perawat unit Hemodialisa, ICU, ICCU, atau HCU.";

    return "";
  }

  get asuhanDirty(): boolean {
    if (!this.doc || !this.asuhan) return false;

    return (
      JSON.stringify(bersihkanAsuhan(this.asuhan)) !== JSON.stringify(bersihkanAsuhan(asuhanDariDoc(this.doc)))
    );
  }

  get instruksiDirty(): boolean {
    if (!this.doc || !this.instruksiForm) return false;

    return (
      JSON.stringify(bersihkanInstruksi(this.instruksiForm)) !==
      JSON.stringify(bersihkanInstruksi(instruksiDariDoc(this.doc)))
    );
  }

  get saveBlockReason(): string {
    const bisaAsuhan = !this.asuhanLockReason;
    const bisaInstruksi = !this.instruksiLockReason;
    if (!bisaAsuhan && !bisaInstruksi) {
      return this.perawatSigned && this.dokterLengkap
        ? "Formulir sudah ditandatangani dokter dan perawat."
        : this.asuhanLockReason || this.instruksiLockReason;
    }
    if (!(bisaAsuhan && this.asuhanDirty) && !(bisaInstruksi && this.instruksiDirty)) {
      return "Tidak ada perubahan yang belum disimpan.";
    }

    return "";
  }

  get signPerawatBlockReason(): string {
    const doc = this.doc;
    if (!doc) return "";
    if (this.aksesReason) return this.aksesReason;
    if (!doc.perawat_id) return "Pilih dan simpan Perawat yang bertugas terlebih dahulu.";
    if (this.asuhanDirty) return "Simpan perubahan terlebih dahulu.";
    if (doc.perawat_id !== this.userId) {
      return `Hanya ${doc.perawat_nama || "perawat yang bertugas"} yang dapat menandatangani asuhan.`;
    }
    if (!doc.monitoring.length) return "Tambahkan minimal satu observasi Monitoring Hemodialisis.";

    return "";
  }

  get signDokterBlockReason(): string {
    const doc = this.doc;
    if (!doc) return "";
    if (this.aksesReason) return this.aksesReason;
    if (!doc.dokter_id) return "Pilih dan simpan Dokter TTD 1 terlebih dahulu.";
    if (this.instruksiDirty) return "Simpan perubahan terlebih dahulu.";
    if (doc.dokter_id !== this.userId) {
      return `Hanya ${doc.dokter_nama || "dokter yang tercatat"} yang dapat menandatangani instruksi medik.`;
    }
    if (!this.instruksiTerisi) return "Isi dan simpan Resep HD atau Heparinisasi terlebih dahulu.";

    return "";
  }

  get signDokterCatatanBlockReason(): string {
    const doc = this.doc;
    if (!doc) return "";
    if (this.aksesReason) return this.aksesReason;
    if (!doc.dokter_catatan_id) return "Pilih dan simpan Dokter TTD 2 terlebih dahulu.";
    if (this.instruksiDirty) return "Simpan perubahan terlebih dahulu.";
    if (doc.dokter_catatan_id !== this.userId) {
      return `Hanya ${doc.dokter_catatan_nama || "dokter yang tercatat"} yang dapat menandatangani obat & catatan medis.`;
    }

    return "";
  }

  get ttdInstruksiIkut(): boolean {
    const doc = this.doc;
    if (!doc || this.dokterSigned || doc.dokter_id === null) return false;

    return doc.dokter_id === doc.dokter_catatan_id && this.instruksiTerisi;
  }

  get instruksiTerisi(): boolean {
    if (!this.doc) return false;
    const isi = { ...this.doc.instruksi } as Record<string, unknown>;
    delete isi.catatan_lain;

    return Object.values(isi).some(v => v !== null && v !== false);
  }

  get hintTtd(): string {
    const kunci = "Setelah ditandatangani, instruksi medik serta obat & catatan medis terkunci.";
    if (this.peranTtd === "dokter") {
      return `Masukkan PIN/Password untuk TTD Dokter 1 (verifikasi dokumen asuhan). ${
        this.dokterCatatanSigned ? kunci : "Isian dokter baru terkunci setelah TTD Dokter 2."
      }`;
    }
    if (this.peranTtd === "dokter_catatan") {
      const ikut = this.ttdInstruksiIkut ? " TTD Dokter 1 ikut terisi karena dokternya sama." : "";
      const lengkap = this.dokterSigned || this.ttdInstruksiIkut;

      return `Masukkan PIN/Password untuk TTD Dokter 2 (verifikasi setelah tindakan HD).${ikut} ${
        lengkap ? kunci : "Isian dokter baru terkunci setelah TTD Dokter 1."
      }`;
    }

    return "Masukkan PIN/Password untuk menandatangani Rekam Asuhan Hemodialisis. Setelah ditandatangani, asuhan dan monitoring terkunci.";
  }

  get waktuHd(): Date | null {
    const v = this.asuhan?.waktu_hd;
    if (!v) return null;
    const [tgl, jam = "00:00"] = v.split(" ");
    const [y, m, d] = tgl.split("-").map(Number);
    const [h, mi] = jam.split(":").map(Number);

    return new Date(y, m - 1, d, h, mi);
  }

  set waktuHd(value: Date | null) {
    if (!this.asuhan || !value) return;
    const pad = (n: number) => String(n).padStart(2, "0");
    this.asuhan.waktu_hd = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(
      value.getHours()
    )}:${pad(value.getMinutes())}`;
  }

  get jumlahIntake(): number | null {
    if (!this.doc) return null;
    let total = 0;
    let terisi = false;
    this.doc.monitoring.forEach(row => {
      [row.intake_nacl, row.intake_dextrose, row.intake_makan_minum, row.intake_lain].forEach(v => {
        if (v !== null) {
          total += v;
          terisi = true;
        }
      });
    });

    return terisi ? total : null;
  }

  get balance(): number | null {
    const totalUf = toNumberOrNull(this.asuhan?.total_uf);
    if (this.jumlahIntake === null || totalUf === null) return null;

    return this.jumlahIntake - totalUf;
  }

  get ufTercapaiTerakhir(): number | null {
    if (!this.doc) return null;
    const rows = this.doc.monitoring.filter(row => row.uf_tercapai !== null);

    return rows.length ? rows[rows.length - 1].uf_tercapai : null;
  }

  get hintTotalUf(): string {
    return this.ufTercapaiTerakhir === null ? "" : `UF tercapai terakhir: ${this.ufTercapaiTerakhir} ml`;
  }

  get namaPasien(): string {
    return storePasien.identitasPasien?.nama || "-";
  }

  get noRm(): string {
    return storePasien.identitasPasien?.rm_dash || this.rm || "-";
  }

  mounted() {
    this.load();
  }

  @Watch("register")
  onRegisterChanged() {
    this.daftar = [];
    this.riwayat = [];
    this.doc = null;
    this.asuhan = null;
    this.instruksiForm = null;
    this.loaded = false;
    this.load();
  }

  async load() {
    if (!this.register) return;

    const seq = ++this.requestSeq;
    const register = this.register;
    this.loading = true;

    try {
      await this.hydrate(async () => {
        const [katalog, hasil] = await Promise.all([
          RekamAsuhanHemodialisisSvc.katalog(),
          RekamAsuhanHemodialisisSvc.getByRegister(register, this.rm)
        ]);
        if (seq !== this.requestSeq || register !== this.register) return;

        const idTerbuka = this.doc?.id;
        this.katalog = katalog;
        this.daftar = hasil.data;
        this.riwayat = hasil.riwayat;
        this.applyDoc(hasil.data.find(it => it.id === idTerbuka) || hasil.data[0] || null, true);
      });
    } finally {
      if (seq === this.requestSeq) this.loading = false;
    }
  }

  applyDoc(doc: RekamAsuhanHemodialisis | null, paksa = false) {
    const pertahankanAsuhan = !paksa && this.asuhanDirty && !doc?.perawat_signed_at;
    const pertahankanInstruksi = !paksa && this.instruksiDirty && !dokterLengkapPada(doc);
    this.doc = doc;
    this.pesanValidasi = "";

    if (!doc) {
      this.asuhan = null;
      this.instruksiForm = null;
      return;
    }

    if (!pertahankanAsuhan || !this.asuhan) this.asuhan = asuhanDariDoc(doc);
    if (!pertahankanInstruksi || !this.instruksiForm) this.instruksiForm = instruksiDariDoc(doc);
    this.perbaruiDaftar(doc);
  }

  perbaruiDaftar(doc: RekamAsuhanHemodialisis) {
    const i = this.daftar.findIndex(it => it.id === doc.id);
    if (i === -1) this.daftar.unshift(doc);
    else this.daftar.splice(i, 1, doc);

    const j = this.riwayat.findIndex(it => it.id === doc.id);
    if (j === -1) this.riwayat.unshift(ringkasan(doc));
    else this.riwayat.splice(j, 1, ringkasan(doc));
  }

  buangPerubahan(): boolean {
    return !this.adaPerubahan || confirm("Ada perubahan yang belum disimpan pada formulir yang sedang dibuka. Buang perubahan tersebut?");
  }

  pilih(id: number) {
    const doc = this.daftar.find(it => it.id === id);
    if (!doc || doc.id === this.doc?.id || this.busy || !this.buangPerubahan()) return;

    this.applyDoc(doc, true);
  }

  async buatFormulir() {
    if (this.createBlockReason || this.creating || !this.buangPerubahan()) return;

    this.creating = true;
    try {
      const doc = await RekamAsuhanHemodialisisSvc.create({
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user?.unit_id ?? null
      });
      this.applyDoc(doc, true);
      appModule.NoticeDelay("Rekam Asuhan Hemodialisis dibuat");
    } finally {
      this.creating = false;
    }
  }

  async simpan() {
    if (!this.doc || !this.asuhan || !this.instruksiForm || this.saveBlockReason) return;

    const form = this.$refs.formRef as (Vue & { validate: () => boolean }) | undefined;
    if (form && !form.validate()) {
      this.pesanValidasi = "Periksa kembali isian bertanda merah sebelum menyimpan.";
      this.$nextTick(() => {
        const galat = (this.$el as HTMLElement).querySelector(".v-input.error--text");
        if (galat) galat.scrollIntoView({ block: "center" });
      });
      return;
    }
    this.pesanValidasi = "";

    const payload: RekamAsuhanHemodialisisUpdate = {};
    if (!this.asuhanLockReason && this.asuhanDirty) {
      Object.assign(payload, bersihkanAsuhan(this.asuhan));
    }
    if (!this.instruksiLockReason && this.instruksiDirty) {
      Object.assign(payload, bersihkanInstruksi(this.instruksiForm));
    }

    this.saving = true;
    try {
      const doc = await RekamAsuhanHemodialisisSvc.update(this.doc.id, payload);
      this.applyDoc(doc, true);
      appModule.NoticeDelay("Rekam Asuhan Hemodialisis berhasil disimpan");
    } finally {
      this.saving = false;
    }
  }

  ubahAsuransi(nilai: string | null) {
    if (!this.asuhan) return;
    this.asuhan.asuransi = nilai;
    if (nilai !== "lainnya") this.asuhan.asuransi_lain = null;
  }

  bukaTtd(peran: PeranTtd) {
    const alasan = {
      dokter: this.signDokterBlockReason,
      dokter_catatan: this.signDokterCatatanBlockReason,
      perawat: this.signPerawatBlockReason
    }[peran];
    if (alasan) return;

    this.peranTtd = peran;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async tandaTangan(password: string) {
    if (!this.doc || !this.peranTtd || this.signing) return;

    const peran = this.peranTtd;
    const ttd1SudahAda = this.dokterSigned;
    this.signing = peran;
    try {
      let doc: RekamAsuhanHemodialisis;
      let pesan: string;
      if (peran === "dokter") {
        doc = await RekamAsuhanHemodialisisSvc.signDokter(this.doc.id, password);
        pesan = "TTD Dokter 1 berhasil";
      } else if (peran === "dokter_catatan") {
        doc = await RekamAsuhanHemodialisisSvc.signDokterCatatan(this.doc.id, password);
        pesan = !ttd1SudahAda && doc.dokter_signed_at ? "TTD Dokter 2 berhasil; TTD Dokter 1 ikut terisi" : "TTD Dokter 2 berhasil";
      } else {
        doc = await RekamAsuhanHemodialisisSvc.signPerawat(this.doc.id, password);
        pesan = "Asuhan hemodialisis berhasil ditandatangani";
      }
      this.applyDoc(doc, true);
      this.modalTtd = false;
      appModule.NoticeDelay(pesan);
    } catch (err) {
      const message = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
      appModule.addMsgTtd(message || "Tanda tangan gagal");
    } finally {
      this.signing = null;
    }
  }

  async hapus() {
    const doc = this.doc;
    if (!doc || !this.bisaHapus || this.busy || this.deleting) return;

    const sudahTtd = !!(doc.perawat_signed_at || doc.dokter_signed_at || doc.dokter_catatan_signed_at);
    const pesan = `${
      sudahTtd ? "Formulir ini sudah ditandatangani. " : ""
    }Anda yakin menghapus Rekam Asuhan Pasien Hemodialisis ini beserta seluruh observasi monitoringnya?`;
    if (!confirmRemove("Rekam Asuhan Pasien Hemodialisis", pesan)) return;

    const register = this.register;
    this.deleting = true;
    try {
      await RekamAsuhanHemodialisisSvc.destroy(doc.id);
      if (register === this.register) {
        this.daftar = this.daftar.filter(it => it.id !== doc.id);
        this.riwayat = this.riwayat.filter(it => it.id !== doc.id);
        this.applyDoc(this.daftar[0] || null, true);
      }
      appModule.NoticeDelay("Rekam Asuhan Hemodialisis berhasil dihapus");
    } finally {
      this.deleting = false;
    }
  }

  async cetak(id: number) {
    if (this.printingId) return;

    this.printingId = id;
    try {
      await RekamAsuhanHemodialisisSvc.openPdf(id);
    } finally {
      this.printingId = null;
    }
  }

  bukaTab(tab: string) {
    if (this.isRanap) {
      this.$emit("navigate-tab", tab === "tab-soap" ? "tab-cppt" : tab);
      return;
    }
    this.$emit("bukaTab", tab);
  }

  formatDateTime(v: string | null): string {
    if (!v) return "-";
    const [tgl, jam = ""] = v.split(" ");
    const [y, m, d] = tgl.split("-");

    return `${d}-${m}-${y}${jam ? " " + jam.slice(0, 5) : ""}`;
  }
}
